import React from 'react';

export default function Chip({ k, v }) {
  return (
    <span className="chip" title={`${k}: ${v}`}>
      <span className="chipK">{k}</span>
      <span className="chipV">{v}</span>
    </span>
  );
}
